import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const DisputesTable = ({
  disputes,
  isLoading,
  isSubmitting,
  formatCurrency,
  formatDateTime,
  statusColor,
  onRespond,
  onRefund,
}) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Disputes</Heading>
          <Text fontSize="sm" color="gray.500">
            {disputes.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : disputes.length === 0 ? (
          <EmptyState title="No disputes" description="Disputed payments will appear after Stripe webhooks." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>ID</Th>
                  <Th>Customer</Th>
                  <Th>Transaction</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {disputes.map((dispute) => (
                  <Tr key={dispute.id}>
                    <Td>{dispute.id}</Td>
                    <Td>{dispute.payerEmail || "-"}</Td>
                    <Td>{dispute.transactionId || "-"}</Td>
                    <Td isNumeric>{formatCurrency(dispute.amount, dispute.currency)}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(dispute.status)}>{dispute.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(dispute.createdAt)}</Td>
                    <Td>
                      <HStack spacing={2} justify="flex-end">
                        <Button size="xs" colorScheme="blue" onClick={() => onRespond(dispute)}>
                          Submit Response
                        </Button>
                        <Button
                          size="xs"
                          variant="outline"
                          colorScheme="orange"
                          onClick={() => onRefund(dispute)}
                          isLoading={isSubmitting}
                        >
                          Refund
                        </Button>
                      </HStack>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default DisputesTable;
